<div class="fleet-module-container py-4">
  <!-- Section Header -->
  <div class="mb-4">
    <app-validation-section-header
      title="Centro de Validaciones"
      [breadcrumbs]="[
        { label: 'Central Monitoreo', route: '/panel' }
      ]"
    ></app-validation-section-header>
  </div>

  <!-- Search & Actions Toolbar -->
  <div class="toolbar-container d-flex flex-row justify-content-between align-items-center mb-4">
    <div class="search-box-wrapper shadow-sm">
      <i class="pi pi-search search-box-icon"></i>
      <input 
        class="search-box-input" 
        type="text" 
        [(ngModel)]="searchTerm" 
        (ngModelChange)="onSearchChange()"
        placeholder="Buscar grupo por nombre o estado..."
      >
    </div>
    <div class="action-buttons">
      <p-splitButton 
        styleClass="custom-split-btn shadow-sm" 
        label="Nueva Validación" 
        icon="pi pi-plus-circle"
        (onClick)="clickCreateFleet()" 
        [model]="options"
      ></p-splitButton>
    </div>
  </div>

  <!-- Loading State overlay -->
  <div class="loading-overlay" [class.loading-hidden]="!(store.loading$ | async)">
    <div class="loading-content">
      <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: var(--gl-primary, #3b82f6);"></i>
      <h4>Procesando información</h4>
      <p>Estamos obteniendo las validaciones...</p>
    </div>
  </div>

  <!-- Board Component -->
  <div class="board-wrapper">
    <app-fleet-checklist-board></app-fleet-checklist-board>
  </div>
</div>

<!-- Modal Dialogs -->
<p-dialog 
  [visible]="fleetEditor.createModalOpen$ | async" 
  [modal]="true" 
  [style]="{width: '50vw'}"
  [breakpoints]="{ '1600px': '75vw', '640px': '100vw' }" 
  [draggable]="false" 
  [resizable]="false" 
  appendTo="body"
  [showHeader]="false"
>
  <app-fleet-checklist-create-view (onCreated)="onCreated($event)"></app-fleet-checklist-create-view>
</p-dialog>

<p-dialog 
  [visible]="fleetEditor.editModalOpen$ | async" 
  [modal]="true" 
  [style]="{width: '50vw'}"
  [breakpoints]="{ '1600px': '75vw', '640px': '100vw' }" 
  [draggable]="false" 
  [resizable]="false" 
  appendTo="body"
  [showHeader]="false"
>
  <app-fleet-checklist-edit-view (onUpdated)="onUpdated($event)"></app-fleet-checklist-edit-view>
</p-dialog>

<p-dialog 
  [visible]="builkEditor.uploadImageModalOpen$ | async" 
  [modal]="true" 
  [draggable]="false"
  [style]="{width: '40vw'}" 
  [breakpoints]="{ '1200px': '75vw', '640px': '100vw' }" 
  [resizable]="false" 
  appendTo="body"
  [showHeader]="false"
>
  <app-upload-programacion-view (onUploaded)="onUploaded($event)"></app-upload-programacion-view>
</p-dialog>
